import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const Title = ({
  cdMissionListLength = 0,
  handleSideFilterMenuCollapseChange = () => {},
  setCdMissionList = () => {},
  setOpenAddModal = () => {},
  setOpenRemoveModal = () => {},
  sideFilterVisible = false,
  translate = () => {},
}) => {
  const renderOptions = () => {
    const list = [
      { label: 'add', action: () => setOpenAddModal(true) },
      { label: 'remove', action: () => setOpenRemoveModal(true) },
      { label: 'cancel', action: () => setCdMissionList([]) },
    ]

    return list.map(({ label, action }) => (
      <Fragment key={label}>
        {' '}
        |{' '}
        <span onClick={action} style={{ color: '#72BF44', cursor: 'pointer' }}>
          {translate(`stockTransfer.missionBlock.selection.${label}`)}
        </span>
      </Fragment>
    ))
  }

  return (
    <div
      style={{
        float: 'left',
        marginTop: '1rem',
        paddingLeft:
          sideFilterVisible && !cdMissionListLength ? '18.5rem' : '1.5rem',
      }}
    >
      {cdMissionListLength ? (
        <div style={{ marginTop: '1rem' }}>
          <strong>{`${cdMissionListLength} ${translate(
            `stockTransfer.missionBlock.selection.quantity${
              cdMissionListLength > 1 ? 'Plural' : 'Singular'
            }`
          )}`}</strong>
          {renderOptions()}
        </div>
      ) : (
        <button
          onClick={() => handleSideFilterMenuCollapseChange(!sideFilterVisible)}
          className='filter-button title'
        >
          <i
            className={`glyph glyph-double-arrow-${
              sideFilterVisible ? 'left' : 'right'
            } glyph-grey icon-size`}
          />
          {translate('mobile.filters')}
        </button>
      )}
    </div>
  )
}

Title.propTypes = {
  cdMissionListLength: PropTypes.number.isRequired,
  handleSideFilterMenuCollapseChange: PropTypes.func.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  setOpenAddModal: PropTypes.func.isRequired,
  setOpenRemoveModal: PropTypes.func.isRequired,
  sideFilterVisible: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Title
